import { PollId, samplePoll } from '../Poll'

export type PollAndVoteCount = {
  pollId: PollId
  voteCount: number
}

export interface HabitatStatistics {
  mostVotedOnOpenPoll?: PollAndVoteCount
}

export const sampleHabitatStatistics = (override?: Partial<HabitatStatistics>): HabitatStatistics => ({
  mostVotedOnOpenPoll: { pollId: samplePoll().id as PollId, voteCount: 86 },
  ...override,
})
